import { BlogPrint } from "./display/BlogPrint.js";

export class Page {

    constructor() {
        e5.console.log("[eventfive.awi.polarstern-v2]", "[Page]");

        this.init();
    }

    private async init() {

        document.querySelectorAll(".awi-blog-print").forEach(
            (e) => {
                new BlogPrint().create({
                    element: e as HTMLDivElement,
                    assetsUrl: e.getAttribute("data-assetsurl"),
                    pdfUrl: e.getAttribute("data-pdfurl")
                })
            });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Page();
});